import { useTranslation } from "react-i18next";
import { useAcctCurrency } from "./useAcctCurrency";
import { NeuInput, NeuSelect } from "../../components/neu/Neu";
import { Field } from "../../components/neu/Field";
import { localName } from "../../lib/localName";

const SEC = "rounded-2xl border border-border/50 bg-background/40 p-4 shadow-neu-sm";
const HEAD = "mb-3 text-[11px] font-black uppercase tracking-wider text-primary";
const PICK = (k, tr) => `-- ${tr(`acct.bills.new.${k}`)} --`;

// نموذج الفاتورة — 4 أقسام واضحة: الأساسيات / المالية / التواريخ والفرع / الملاحظات.
export const BillFormFields = ({ form, set, categories, suppliers, branches }) => {
  const { t } = useTranslation();
  const currency = useAcctCurrency();
  return (
    <div className="mt-6 grid gap-4">
      <div className={SEC}>
        <p className={HEAD}>{t("acct.bills.new.secBasic")}</p>
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label={t("acct.bills.new.invoiceNo")} testId="bill-invno"
                 value={form.supplier_invoice_no} onChange={set("supplier_invoice_no")}
                 placeholder={t("acct.bills.new.invoicePh")} />
          <div>
            <p className="label-xs mb-2">{t("acct.bills.new.category")} *</p>
            <NeuSelect data-testid="bill-cat" value={form.expense_account} onChange={set("expense_account")}>
              <option value="">{PICK("pickCategory", t)}</option>
              {categories.map((a) => <option key={a.code} value={a.code}>{a.code} — {localName(a)}</option>)}
            </NeuSelect>
          </div>
          <div className="sm:col-span-2">
            <p className="label-xs mb-2">{t("acct.bills.new.supplier")} *</p>
            <NeuSelect data-testid="bill-sup" value={form.supplier_id} onChange={set("supplier_id")}>
              <option value="">{PICK("pickSupplier", t)}</option>
              {suppliers.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </NeuSelect>
            <NeuInput className="mt-2" data-testid="bill-sup-new" value={form.supplier_new}
                      onChange={set("supplier_new")} placeholder={t("acct.bills.new.newSupplier")} />
          </div>
        </div>
      </div>

      <div className={SEC}>
        <p className={HEAD}>{t("acct.bills.new.secAmount")}</p>
        <div className="grid gap-4 sm:grid-cols-3">
          <Field label={t("acct.bills.new.amount") + " *"} testId="bill-amt" type="number"
                 value={form.amount} onChange={set("amount")} placeholder="0.00" />
          <Field label={t("acct.bills.new.tax")} testId="bill-tax" type="number"
                 value={form.tax} onChange={set("tax")} placeholder="0.00" />
          <div>
            <p className="label-xs mb-2">
              {t("acct.bills.new.currency")}{" "}
              <span className="text-muted-foreground">({t("acct.bills.new.branchCurr")})</span>
            </p>
            <NeuInput data-testid="bill-cur" value={currency} disabled className="opacity-70" />
          </div>
        </div>
      </div>

      <div className={SEC}>
        <p className={HEAD}>{t("acct.bills.new.secWhen")}</p>
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label={t("acct.bills.new.date") + " *"} testId="bill-date" type="date"
                 value={form.date} onChange={set("date")} />
          <Field label={t("acct.bills.new.due")} testId="bill-due" type="date"
                 value={form.due_date} onChange={set("due_date")} />
          <div>
            <p className="label-xs mb-2">{t("acct.bills.new.branch")} *</p>
            <NeuSelect data-testid="bill-br" value={form.branch_id} onChange={set("branch_id")}>
              <option value="">{PICK("pickBranch", t)}</option>
              {branches.map((b) => <option key={b.id} value={b.id}>{localName(b)}</option>)}
            </NeuSelect>
          </div>
          <label className="flex items-center gap-2 self-end pb-2 text-sm">
            <input type="checkbox" data-testid="bill-recurring" checked={form.is_recurring}
                   onChange={(e) => set("is_recurring")(e.target.checked)} />
            {t("acct.bills.new.recurring")}
          </label>
        </div>
      </div>

      <div className={SEC}>
        <p className={HEAD}>{t("acct.bills.new.secNotes")}</p>
        <Field label={t("acct.bills.new.description")} testId="bill-desc"
               value={form.description} onChange={set("description")}
               placeholder={t("acct.bills.new.descPh")} />
      </div>
    </div>
  );
};
